export enum UnitDimension {
  Time = 1,
  Length = 2,
  Area = 3,
  Volume = 4,
  Weight = 5,
  Capacity = 6,
  Speed = 7,
  Power = 8,
  Quantity = 9,
  MassRatio = 10,
  Torque = 11,
  Force = 12,
  RotationSpeed = 13,
  MechanicalPower = 14,
  HorsePower = 15,
  LiterConsumption = 16,
  CubicFlowRate = 17,
  Percentage = 18,
  ElectricCharge = 19,
  Pressure = 20,
  Voltage = 21,
  SoundLevel = 22,
  LuminousFlux = 23,
  Packaging = 24,
  Temperature = 25,
  Angle = 26,
  Energy = 27,
}

export const COMPONENT_DIMENSION: { [component: number]: UnitDimension } = {
  1: UnitDimension.Area,
  6: UnitDimension.Time,
  8: UnitDimension.Length,
  14: UnitDimension.Volume,
  15: UnitDimension.Capacity,
  16: UnitDimension.Length,
  17: UnitDimension.Speed,
  18: UnitDimension.Length,
  19: UnitDimension.Length,
  20: UnitDimension.Length,
  21: UnitDimension.Weight,
  24: UnitDimension.Quantity,
  25: UnitDimension.Time,
}
